(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newUser', {
            parent: 'application',
            url: '/user/new',
            data: {
                authorities: ['USER_RESOURCE'],
                pageTitle: 'Nowy użytkownik - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/newUser/newUser.html',
                    controller: 'newUserController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
